import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '@eagleview/ev-comp-library/dist/lib/main.css';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { EVThemeProvider } from '@eagleview/ev-comp-library';
import { LAUNCH_DARKLY_CLIENT_ID } from './constants/AppConstants';
import App from './App';

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: LAUNCH_DARKLY_CLIENT_ID,
  });
  ReactDOM.render(
    <EVThemeProvider classPrefix="am">
      <LDProvider>
        <App />
      </LDProvider>
    </EVThemeProvider>,
    document.getElementById('root'),
  );
})();
